
import moment from 'moment';

const DateFormatter = ({ date }) => {
    if (!date) {
        return 'date format invalid';
    }

    return moment(date).isValid() ? moment(date).format('YYYY/MM/DD') : 'Date invalide';
}

export default DateFormatter;
